import React from 'react';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { connect } from 'react-redux';
import { addCategoryAction } from '../../redux/actions';

const topNavigatorStyle = {
    height: '50px',
    width: '100%',
    color: '#515151',
}

class TopNavigator extends React.Component {
  state = {
      value: 0
  }

  render () {
      const { categories } = this.props;
      return (
        <div className="col-md-3 offset-md-4">
          <Tabs
            TabIndicatorProps={{
                style: {
                backgroundColor: this.props.shopColor
                }
            }}
            value={this.props.value}
            variant="scrollable"
            scrollButtons="on"
            style={topNavigatorStyle}
            onChange={(event, index) => {
                this.props.addCategory(categories[index]);
            }}
          >
            {categories.map((category, index) => (
                <Tab key={index} label={category} />
            ))}
          </Tabs>
        </div>  
      );
  }  
};

const mapStateToProps = (state) => ({
	shopColor: state.shopColor
});

const mapDispatchToProps = (dispatch) => ({

	addCategory(food) {
		dispatch(addCategoryAction(food));
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(TopNavigator);

